import styles from "./SkeletonContent.module.scss";

export function SkeletonContent() {
  return <div className={styles.skeleton} />;
}
